import { memo } from 'react';
import { NavLink } from 'react-router-dom';
import Typography from '@lib/components/Typography/Typography';
import LinkComponent, { LinkTypes } from '@lib/components/Link/Link';
import styles from './SsoProviderNameCell.module.scss';

interface Props {
  iconSrc: string;
  name: string;
  url: string;
}

function SsoProviderNameCell({ iconSrc, name, url }: Props) {
  return (
    <LinkComponent
      to={url}
      component={NavLink}
      type={LinkTypes.tertiaryBlack}
      underline={false}
    >
      <div className={styles.wrap}>
        <div className={styles.icon}>
          <img src={iconSrc} alt="" />
        </div>
        <div className={styles.info}>
          <Typography variant="caption" strong>
            {name}
          </Typography>
        </div>
      </div>
    </LinkComponent>
  );
}

export default memo(SsoProviderNameCell);
